/** @format */

import React from 'react'
import Navbar from "./navbar";
import Footer from "./footer";


class Home extends React.Component {
	render() {
		return (
			<>
				<Navbar />
				<div
					id='template-mo-zay-hero-carousel'
					className='carousel slide margin-home'
					data-bs-ride='carousel'>
					<ol className='carousel-indicators'>
						<li
							data-bs-target='#template-mo-zay-hero-carousel'
							data-bs-slide-to='0'
							className='active'></li>
						<li
							data-bs-target='#template-mo-zay-hero-carousel'
							data-bs-slide-to='1'></li>
						<li
							data-bs-target='#template-mo-zay-hero-carousel'
							data-bs-slide-to='2'></li>
					</ol>
					<div className='carousel-inner '>
						<div className='carousel-item active'>
							<div className='container'>
								<div className='row p-5'>
									<div className='mx-auto col-md-8 col-lg-6 order-lg-last'>
										<img
											className='img-fluid'
											src='./assets/img/home/banner_img_01.jpg'
											alt='banner'
											width='500'
											height='300'
										/>
									</div>
									<div className='col-lg-6 mb-0 d-flex align-items-center'>
										<div className='text-align-left align-self-center'>
											<h3 className='h2 text-success'>
												We assist farmers to grow
											</h3>
											<p>
												SabZ seeks to address logistical problems and also
												help farmers get good value to the produce by
												eliminating the involvement of various
												intermediaries.We also make every effort to mitigate
												post-harvest losses.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className='carousel-item '>
							<div className='container'>
								<div className='row p-5'>
									<div className='mx-auto col-md-8 col-lg-6 order-lg-last'>
										<img
											className='img-fluid'
											src='./assets/img/home/banner_img_02.jpg'
											alt='banner'
											width='500'
											height='300'
										/>
									</div>
									<div className='col-lg-6 mb-0 d-flex align-items-center'>
										<div className='text-align-left'>
											<h3 className='h2 text-success'>
												we help businesses to extend their operations{' '}
											</h3>
											<p>
												we aid businesses in purchasing fresh produce at a
												reduced cost. Through the credit model, businesses
												can tackle their cash crunch issues. They can
												concentrate on growing their sales while incurring
												fewer expenses on a regular basis.We extend credit
												to businesses (among our clientele), as identified
												by our machine learning model, and assist them in
												extending their operations rather than concentrating
												on day-to-day bills.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <div className='carousel-item'>
							<div className='container'>
								<div className='row p-5'>
									<div className='mx-auto col-md-8 col-lg-6 order-lg-last'>
										<img
											className='img-fluid'
											src='./assets/img/home/banner_img_03.jpg'
											alt='banner'
											width='500'
											height='300'
										/>
									</div>
									<div className='col-lg-6 mb-0 d-flex align-items-center'>
										<div className='text-align-left'>
											<h3 className='h2 text-success'>
												Goods directly from farm to consumer's door !!!!
											</h3>
											<p>
												We try to bridge the gap between the farmers and the
												consumers by transporting goods from the farm
												directly to our designated customers, both B2B and
												B2C.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div> */}
					</div>
					<a
						className='carousel-control-prev text-decoration-none w-auto ps-3'
						href='#template-mo-zay-hero-carousel'
						role='button'
						data-bs-slide='prev'>
						<i className='fas fa-chevron-left'></i>
					</a>
					<a
						className='carousel-control-next text-decoration-none w-auto pe-3'
						href='#template-mo-zay-hero-carousel'
						role='button'
						data-bs-slide='next'>
						<i className='fas fa-chevron-right'></i>
					</a>
				</div>

				<section className='container py-1'>
					<div className='row text-center pt-1'>
						<div className='col-lg-6 m-auto'>
							<h1 className='h1'>
								{' '}
								<b>Our featured products</b>
							</h1>
							<p></p>
						</div>
					</div>

					<div className='row'>
						<div className='col-12 col-md-4 p-5 mt-2'>
							<a href='/'>
								<img
									src='./assets/img/home/leafy vegetables.jpg'
									alt='leafy vegetables'
									width='300'
									height='700'
									className='rounded-circle img-fluid border'
								/>
							</a>
							<h2 className='h5 text-center mt-3 mb-3'>Leafy vegetables</h2>
							{/* <!-- <p className="text-center"><a className="btn btn-success" href="shop.html">Go Shop</a></p> --> */}
						</div>
						<div className='col-12 col-md-4 p-5 mt-2'>
							<a href='/'>
								<img
									src='./assets/img/home/Category_img_01.jpg'
									alt='Category_img_01'
									width='300'
									height='700'
									className='rounded-circle img-fluid border'
								/>
							</a>
							<h5 className=' h5 text-center mt-3 mb-3'>Vegetables</h5>
							{/* <!-- <p className="text-center"><a className="btn btn-success" href="shop.html">Go Shop</a></p> --> */}
						</div>
						<div className='col-12 col-md-4 p-5 mt-2'>
							<a href='/'>
								<img
									src='./assets/img/home/category_img_02.jpg'
									alt='category_img_02'
									width='300'
									height='700'
									className='rounded-circle img-fluid border'
								/>
							</a>
							<h2 className='h5 text-center mt-3 mb-3'>Fruits</h2>
							{/* <!-- <p className="text-center"><a className="btn btn-success" href="shop.html">Go Shop </a></p> --> */}
						</div>
					</div>
				</section>

				<section className='bg-light' id='contact'>
					<div className='container py-1'>
						<div className='row text-center py-3'>
							<div className='col-lg-6 m-auto'>
								<h1 className='h1'>
									{' '}
									<b>Give your Feedback </b>
								</h1>
								<p>User can send their any comments and feedback in this section</p>
							</div>
						</div>

						<div className='container col-12'>
							<div className='row'>
								<div className='col-lg-6'>
									<div className='mapouter'>
										<div className='gmap_canvas'>
											<iframe
												title='map'
												width='600'
												height='500'
												id='gmap_canvas'
												src="https://maps.google.com/maps?q=Sripuram,%20B%20N%20Reddy%20Nagar,%20Hyderabad,%20Telangana%20500070&t=&z=13&ie=UTF8&iwloc=&output=embed" 
												frameborder='0'
												scrolling='no'
												marginheight='0'
												marginwidth='0'></iframe>
											<br />

										</div>
									</div>
								</div>
								<div className='col-lg-6'>
									<form className='col-md-9 m-auto' method='post'>
										<div className='row'>
											<div className='form-group col-md-6 mb-3'>
												<label for='inputname'>Name</label>
												<input
													type='text'
													className='form-control mt-1'
													id='name'
													name='name'
													placeholder='Name'
												/>
											</div>
											<div className='form-group col-md-6 mb-3'>
												<label for='inputemail'>Email</label>
												<input
													type='email'
													className='form-control mt-1'
													id='email'
													name='email'
													placeholder='Email'
												/>
											</div>
										</div>
										<div className='mb-3'>
											<label for='inputsubject'>Subject</label>
											<input
												type='text'
												className='form-control mt-1'
												id='subject'
												name='subject'
												placeholder='Subject'
											/>
										</div>
										<div className='mb-3'>
											<label for='inputmessage'>Message</label>
											<textarea
												className='form-control mt-1'
												id='message'
												name='message'
												placeholder='Message'
												rows='8'></textarea>
										</div>
										<div className='row'>
											<div className='col text-end mt-2'>
												<button
													type='submit'
													className='btn btn-success btn-lg px-3'>
													Let’s Talk
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Footer />

				
			</>
		)
	}
}
export default Home
